export default {"src":"/_next/static/media/blob-pattern.72db2438.svg","height":340,"width":568,"blurWidth":0,"blurHeight":0};